export default __webpack_public_path__ + "total-module-dark-icon.svg";